'use client';

import SpinnerLoader from '@/components/common/SpinnerLoader';
import { useIsMobile } from '@/hooks/useIsMobile';

export default function LazyLoadingWrapper({
  loading,
  initial = false,
  hasPadding = true,
  children,
}: {
  loading: { ref: React.RefObject<HTMLDivElement>; inView: boolean };
  initial?: boolean;
  hasPadding?: boolean;
  children: React.ReactNode;
}) {
  const isMobile = useIsMobile();

  return (
    <div
      ref={loading.ref}
      style={{
        minHeight: !initial && !loading.inView ? '50vh' : 0,
      }}
      className={hasPadding && !isMobile ? 'px-5' : ''}
    >
      {initial || loading.inView ? children : <SpinnerLoader />}
    </div>
  );
}
